const lazyBGImageInit = () => {
  document.addEventListener('lazybeforeunveil', function (e) {
    const bg = e.target.getAttribute('data-bgset');
    if (bg) {
      e.target.style.backgroundImage = `url(${bg})`;
    }
  });
};

export default lazyBGImageInit;
